<template>
  <tf-table-parent-row
    :key="source.id"
    @mouseover.native="isHovering = true"
    @mouseout.native="isHovering = false"
  >
    <tf-table-td
      :class="{ 'is-readonly': !isEditing }"
      :colspan="colspan"
    >
      <source-item
        v-bind="{ source, isHovering }"
        :is-editing.sync="isEditing"
        @delete="$emit('delete', $event)"
        @save="$emit('save', $event)"
      />
    </tf-table-td>
    <template v-if="!isEditing">
      <tf-table-td v-if="showDate">
        <span>{{ $TF.DatesUtils.formatSimpleDate(source.created_at, 'MM/DD/YY') }}</span>
      </tf-table-td>
      <tf-table-td>
        <tf-button
          :loading="isDownloading"
          type="primary"
          icon="file-download"
          size="icon-no-fill"
          no-border
          @click="downloadSource"
        />
      </tf-table-td>
    </template>
  </tf-table-parent-row>
</template>

<script>
  // utils
  import { getSource } from '@/utils/file';
  // components
  import SourceItem from '@/components/Source/Item';

  /**
   * The "SourceTableRow" component is used to control the editing, downloading and hovering state of the row data where the row is made up of a source column, cta column, and potentially a date column.
   *
   * @vuedoc
   * @exports SourceTableRow
   * @category Components
   */
  export default {
    name: 'SourceTableRow',
    components: { SourceItem },
    props: {
      showDate: {
        type: Boolean,
        default: false,
      },
      source: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      isEditing: false,
      isDownloading: false,
      isHovering: false,
      getSource,
    }),
    computed: {
      /**
       * Evaluate the editing state along with the showDate parameter to determine what the colspan for the source name in the template will be.
       *
       * @returns {number}
       */
      colspan() {
        let colspan = 1;

        if (this.isEditing) {
          colspan = this.showDate ? 3 : 2;
        }

        return colspan;
      },
    },
    methods: {
      /**
       * Download a single file based on the source ID of the component.
       */
      downloadSource() {
        if (this.isDownloading) {
          return;
        }

        this.isDownloading = true;

        this
          .getSource(this.source.id)
          .catch(() => {
            this.showMessage('downloading');
            this.$message({
              duration: 3000,
              message: 'There was a problem downloading the file.',
              showClose: true,
              type: 'error',
            });
          })
          .finally(() => {
            this.isDownloading = false;
          });
      },
    },
  };
</script>

<style scoped lang="scss">
  ::v-deep .container-source {
    padding: 0;
  }

  .is-readonly {
    padding-right: 0;
  }

  span {
    display: flex;
    align-items: center;
    height: 30px;
  }
</style>
